<template>
    <div class="delete-dialog">
        <el-dialog :visible="visible" title="删除任务" destroy-on-close width="800px" :close-on-click-modal='false'
            :close-on-press-escape='false' @close="handleClose">
            <div class="delete-form-box">
                <dc-form ref='dcForm' refName="customerForm" :row="addNewMainData" :config="FIELDS" label-width="100px"
                    @data-changed="handleFormDataChange" class="delete-form">
                     <template v-slot:form-append="{ form, itemSetting, rIndex }">
                        <el-form-item :label="itemSetting.label" :prop="itemSetting.prop"
                            :label-width="itemSetting.labelWidth ||'70px'">
                            <div class="customer-select-list" v-if="itemSetting.prop==='customerNameList'" :title="form[itemSetting.prop]">
                                {{ form[itemSetting.prop] }}
                            </div>
                            <el-input
                                v-else-if="itemSetting.prop==='abandonReason'"
                                type="textarea"
                                :rows="5"
                                placeholder="请输入"
                                v-model="form[itemSetting.prop]">
                            </el-input>
                        </el-form-item>
                    </template>
                </dc-form>
            </div>

            <span slot="footer">
                <el-button size="mini" @click="closeVisible(false)">取消</el-button>
                <el-button type="primary" size="mini" @click="confirmHandle">删除</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, computed } from '@vue/composition-api';
import { formConfig } from './config.js';
import {
    batchDeleteCustomerVisitApi } from '@mdm/api/customer/customerVisitManage.js';
import { Message } from 'element-ui';
import dcForm from '@/modules/mdm/components/form/Index.vue';
import _ from 'lodash';

export default {
    components: { dcForm },
    props: { },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(formConfig);
        const emit = setupContext.emit;

        const _addNewMainData = {

        };
        const addNewMainData = ref(_.cloneDeep(_addNewMainData));
        const FIELDS = computed(() => {
            return config.fields;
        });

        const handleFormDataChange = ({ data, form, itemSetting }) => {
            addNewMainData.value = Object.assign(addNewMainData.value, form);
        };

        const visible = ref(false);
        const showParams = ref({ });
        const show = (val) => {
            visible.value = true;
            showParams.value = val;
            const customerNameList = val?.map(it => it.customerName).join(',');
            addNewMainData.value = Object.assign({ customerNameList }, _addNewMainData, val);
            setupContext.root.$nextTick(() => {
                setupContext.refs.dcForm.$refs.customerForm.clearValidate();
            });
        };

        const handleClose = () => {
            visible.value = false;
        };
        const closeVisible = (val = false) => {
            visible.value = val;
        };
        const confirmHandle = () => {
            addNewMainData.value = setupContext.refs.dcForm.form;
            setupContext.refs.dcForm.validateForm().then(async () => {
                const params = _.pick(setupContext.refs.dcForm.form, ['abandonReason']);
                params.ids = showParams.value.map(it => it.id);
                batchDeleteCustomerVisitApi(params).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('删除成功');
                        // 调用外部确认删除的回调
                        setupContext.emit('confirm-update');
                        visible.value = false;
                    }
                });
            });
        };
        return {
            emit,
            config,
            addNewMainData,
            FIELDS,
            visible,
            closeVisible,
            confirmHandle,
            handleFormDataChange,
            show,
            handleClose
        };
    }
};
</script>
<style lang="less" scoped>
.delete-form-box{
    padding: 20px;
    .customer-select-list{
        max-height:110px;
        overflow-y: auto;
    }
}
</style>
